/**
 * Created by Henry Huang on 2018/7/10.
 */
import {MCCListType} from "../../services/DataService";
import {Account} from "../accounts/accounts";

export interface PaymentMethodOption {
  value: PaymentMethod
  name: string
}

export enum PaymentMethod {
  AP = 'ap',
  APW = 'apw',
  YSF = 'ysf',
  LZF = 'lzf',
  CARD = 'card'
}

export interface SwipeCardAccount {
  name: string,
  title: string,
  remark?: string,
  type: string,
  bankName: string,
  amount: number,
  liability: number,
  half: boolean,
  paymentMethod?: PaymentMethod,
  defaultMachineType?: string,
  priorityHigh?: boolean
}

export interface CardSwipingInfo {
  accountName: string
  amount: number
  swiped: boolean
}

export interface CardSwipingInfoMap {
  [name: string]: CardSwipingInfo
}

export interface SwipingCardsSettings {
  rate: number
  basedAmount: number
  mccAndTime?: MCCAndTime
}

export interface SwipingCardsInfo {
  totalAmount: number
  totalArrived: number
  totalCharge: number
  totalAccountCount?: number
  swipedCount: number
}

export interface SCState {
  bizDate: number
  allAccounts: SwipeCardAccount[]
  cardSwipingInfoMap: CardSwipingInfoMap
  settings: SwipingCardsSettings
  swipingInfo: SwipingCardsInfo
  accountsRaw: Account[]
}

export interface MCCListRaw {
  key: string;
  name: string;
  timeRanges: {
    [hrKey: string]: {
      [minKey: string]: MCCInfo[]
    }
  }
}

export interface MCCInfo {
  category: string,
  mccs: number[],
  rating?: number
}

export interface MCCAndTime {
  key: string,
  hourRange?: string,
  minuteRange?: string,
  mccInfos?: MCCInfo[],
  desc: string
}

export interface SCOrderStep {
  index: number,
  swipingCardsSettings: SwipingCardsSettings
  paymentMethods: PaymentMethod[],
  mccType: MCCListType,
  accounts: SwipeCardAccount[],
  cardSwipingInfoMap: CardSwipingInfoMap,
  priorityHigh: boolean
}
